/* eslint-disable */
import React, { useState, useEffect, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { format, addYears, parseISO, addDays } from "date-fns";
import { apiService } from "../../api/dataverseApi";
import {
  updateSingleCart,
  updateMultiCart,
  getTotalCartQuantity,
} from "../../store/reducers/subscripion";
import { selectID } from "../../features/counter/counterSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { handleDeleteAction } from "./cartUtils";

const NavBar = React.lazy(() => import("../../components/navBar"));
const TopicBanner = React.lazy(() => import("../../components/topicBanner"));
const Footer = React.lazy(() => import("../../components/footer"));

const MyCart = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const search = location.search;
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const [cartItems, setCartItems] = useState([]);
  const authID = useSelector(selectID);
  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    setIsLoading(true);
    try {
      const items = await apiService.getCart();
      const cartItem = items.find(
        (item) => item.subscriptionid === "151" || item.subscriptionid === "168"
      );
      if (!cartItem) {
        setCartItems(null);
        return;
      }
      if (cartItem) {
        const { description, startDate, endDate } =
          handleSubscriptionDatesAndDescription(
            cartItem.ordertype,
            cartItem.currentsubscriptionenddate
          );
        const enrichedCartItem = {
          ...cartItem,
          startDate,
          endDate,
          description,
        };

        setCartItems(enrichedCartItem);
        if (cartItem.subscriptionid === "151") {
          dispatch(
            updateSingleCart({
              cartsId: cartItem.cartsid,
              quantity: cartItem.quantity,
            })
          );
        } else {
          dispatch(
            updateMultiCart({
              cartsId: cartItem.cartsid,
              quantity: cartItem.quantity,
            })
          );
        }
      }
    } catch (error) {
      console.error("Failed to fetch cart:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const goToCheckoutPage = async () => {
    if (!authID.u) {
      navigate("/userConfirmation", {
      state: { cartItems }
    });
    }

    if (
      authID.u &&
      authID.u.authenticationSource == "localAccountAuthentication"
    ) {
      // check  user cart eligibility
      const { allowed, message } = await checkUserCartEligibility(
        authID?.u?.["signInNames.emailAddress"],
        cartItems
      );
      if (!allowed) {
        alert(message);
        handleDeleteAction(
          cartItems.cartsid,
          cartItems.subscriptionid === "151" ? "single" : "multiple",
          dispatch
        );
        return;
      }
      navigate( "/checkout", {
        state: { cartItems }
      });
    } else if (
      authID.u &&
      authID.u.authenticationSource == "socialIdpAuthentication"
    ) {
      alert(
        " openathen account is not suitable for checkout.Please login with your local account to proceed to checkout page"
      );
    }
  };

  const handleSubscriptionDatesAndDescription = (
    ordertype,
    currentsubscriptionenddate
  ) => {
    const baseText = "Therapeutic Guidelines 12 month subscription";
    const formatToMidnightUTC = (date) => {
      const d = new Date(date);
      d.setUTCHours(0, 0, 0, 0);
      return d.toISOString().replace(/\.000Z$/, "Z");
    };

    try {
      switch (ordertype) {
        case "New": {
          const today = new Date();
          return {
            description: `${baseText} (expires ${format(
              addYears(today, 1),
              "dd-MMM-yyyy"
            )})`,
            startDate: formatToMidnightUTC(today),
            endDate: formatToMidnightUTC(addYears(today, 1)),
          };
        }

        case "Renew": {
          const renewalStart = addDays(parseISO(currentsubscriptionenddate), 1);
          return {
            description: `${baseText} renewal (expires ${format(
              addYears(renewalStart, 1),
              "dd-MMM-yyyy"
            )})`,
            startDate: formatToMidnightUTC(renewalStart),
            endDate: formatToMidnightUTC(addYears(renewalStart, 1)),
          };
        }

        case "Addon":
          const endDate = parseISO(currentsubscriptionenddate);
          const startDate = addYears(endDate, -1); // Subtract 1 year from end date
          return {
            description: `${baseText} additional licenses (expires ${format(
              parseISO(currentsubscriptionenddate),
              "dd-MMM-yyyy"
            )})`,
            startDate: formatToMidnightUTC(startDate),
            endDate: formatToMidnightUTC(endDate),
          };

        default:
          return {
            description: baseText,
            startDate: null,
            endDate: null,
          };
      }
    } catch (error) {
      console.error("Error processing subscription:", error);
      return {
        description: baseText,
        startDate: null,
        endDate: null,
      };
    }
  };

   async function checkUserCartEligibility(email, cartItems) {
    try {
      const response = await apiService.getUserProfile(email);
      console.log("subscriptions CHECK IN CART", response);
      const { subscriptions, contact } = response.data;

      const endDate = new Date(subscriptions?.tg_expirydate);
      const today = new Date();
      let fourMonthsBefore = null;
      let threeMonthsAfter = null;

      if (endDate) {
        fourMonthsBefore = new Date(endDate);
        fourMonthsBefore.setMonth(endDate.getMonth() - 4);
        threeMonthsAfter = new Date(endDate);
        threeMonthsAfter.setMonth(endDate.getMonth() + 5);
      }

      // child account cannot make a purchase
      if (
        contact?._tg_parentcontactid_value !== undefined &&
        contact?._tg_parentcontactid_value !== null
      ) {
        return {
          allowed: false,
          message:
            "Your sub-account is managed by a primary account admin. You cannot make a purchase as a sub-account user, so we will clear your cart. Please contact your primary account admin if you’d like to renew your subscription.",
        };
      }
      
      if (!subscriptions || !endDate) {
        if (cartItems?.ordertype === "New") {
          return { allowed: true, message: "" };
        } else {
          return {
            allowed: false,
            message:
              "You don't have an active subscription. Please purchase a new subscription from the home page.",
          };
        }
      }

      //cart new item
      //no subscipttion or current subscription and end date + month is smaller than today
      if (cartItems?.ordertype == "New") {
        if (!subscriptions || endDate === null) {
          return { allowed: true, message: "" };
        } else if (today > threeMonthsAfter) {
          return { allowed: true, message: "" };
        } else if (today >= fourMonthsBefore && today <= threeMonthsAfter) {
          return {
            allowed: false,
            message:
              "You are trying to purchase a new subscription during your renewal period. To renew your subscription, please go to My account>> My subscriptions and click the ‘renew’ button.",
          };
        } else {
          return {
            allowed: false,
            message:
              "You currently have an active subscription, so there's no need to buy a new one. We will clear your cart.",
          };
        }
      }
      // cart renew item
      if (cartItems?.ordertype == "Renew") {
        if (
          subscriptions &&
          today >= fourMonthsBefore &&
          today <= threeMonthsAfter
        ) {
          if (cartItems?.subscriptionid === subscriptions.tg_subscriptionid) {
            return { allowed: true, message: "" };
          } else {
             return {
              allowed: false,
              message:
                "The subscription type you’ve added to cart doesn’t match your current subscription. If you are interested in renewing your current subscription, then please head to My account>> My subscriptions and tap the ‘renew’ button.  If you want to add/remove any number of licences, please contacted the IT Support Team via support@tg.org.au",
            };
          }
        } else if (subscriptions && today <= fourMonthsBefore) {
          return {
            allowed: false,
            message:
              "Thanks for trying to renew your subscription early! You currently have an active subscription. So, we’ll clear your cart as your renewal period hasn’t started yet.",
          };
        } else {
          return {
            allowed: false,
            message:
              "You don’t have an active subscription with Therapeutic Guidelines. Please purchase a new subscription via the home page at app.tg.org.au.",
          };
        }
      }
      // cart addon item
      // have to be 168 and
      if (cartItems?.ordertype == "Addon") {
        if (
          subscriptions.tg_subscriptionid === "168" &&
          endDate > today &&
          subscriptions.tg_numberoflicences + cartItems.quantity <= 5
        ) {
          return { allowed: true, message: "" };
        } else {
          return {
            allowed: false,
            message:
              "Sorry, we can’t add a licence to your subscription. You currently may not have an active Multi-user subscription, or you have reached the Multi-user licence limit. Please contact IT Support via support@tg.org.au for assistance",
          };
        }
      }
    } catch (error) {
      console.error("Error in checkUserCartEligibility:", error);
      return {
        allowed: false,
        message:
          "A subscription item has been cleared from your cart due to inactivity, or a connection error. Please return to the home page at app.tg.org.au and add the subscription of your choice to cart and checkout again.",
      };
    }
  }
  return (
    <Suspense fallback={<div className="loader"></div>}>
      <NavBar push={navigate} />
      <TopicBanner pathname={pathname} search={search} push={navigate} />

      {isLoading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p>Loading your cart items...</p>
        </div>
      ) : !cartItems ? (
        <div className="container myCart">
          <div className="col-lg-8 col-sm-8 col-xs-12 no_left_padding noRightPaddingxs empty-cart-message">
            No item found in your cart
          </div>
        </div>
      ) : (
        <div className="container myCart">
          <div className="col-lg-8 col-sm-8 col-xs-12 no_left_padding noRightPaddingxs">
            <h4 className="section-heading margintp-10px">My purchases</h4>

            <div id="responsive-tables">
              <table className="table table-bordered" id="myPurchases">
                <thead className="th_color">
                  <tr>
                    <th className="col-6 col-sm-12 text-center">Product</th>
                    <th className="col-2 col-md-1 col-sm-3 text-center">
                      Quantity
                    </th>
                    <th className="col-3 col-md-2 col-sm-3 text-center">
                      Total price (AUD, incl GST)
                    </th>
                    <th className="col-1 col-sm-3"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td
                      className="mycartitem col-6 col-sm-12"
                      data-title="Item"
                    >
                      {cartItems.description}
                    </td>
                    <td
                      className="Quantity col-2 col-md-1 col-sm-3"
                      data-title="Quantity"
                    >
                      {cartItems.quantity}
                    </td>
                    <td
                      className="mycartprice col-3 col-md-2 col-sm-3"
                      data-title="Price"
                    >
                      $
                      {cartItems.subscriptionid === "151"
                        ? cartItems.individualprice?.toFixed(2)
                        : cartItems.multipleprice?.toFixed(2)}
                    </td>
                    <td className="action col-1 col-sm-3">
                      <a
                        className="text_none"
                        href="#"
                        onClick={() =>
                          handleDeleteAction(
                            cartItems.cartsid,
                            cartItems.subscriptionid === "151"
                              ? "single"
                              : "multiple",
                               dispatch
                          )
                        }
                      >
                        <i className="fa fa-trash-o font20px"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr className="footr_color">
                    <td colSpan="2" className="totalprice text-right">
                      Total :
                    </td>
                    <td colSpan="2" className="totalprice" id="finalprice">
                      {cartItems.subscriptionid === "151"
                        ? cartItems.individualprice?.toLocaleString("en-AU", {
                            style: "currency",
                            currency: "AUD",
                          })
                        : cartItems.multipleprice?.toLocaleString("en-AU", {
                            style: "currency",
                            currency: "AUD",
                          })}
                    </td>
                  </tr>
                </tfoot>
              </table>
              <p className="text-right">
                <a
                  href="/"
                  className="btn btn-sm btn-default"
                  title="Continue shopping"
                >
                  Continue shopping
                </a>
                <button className="btn btn-info" onClick={goToCheckoutPage}>
                  Proceed to checkout
                </button>
              </p>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </Suspense>
  );
};

export default MyCart;
